import React from "react"
import FormBusiness from "./Form"

export default function CreateBusiness() {
  return <FormBusiness />
}



// WEBPACK FOOTER //
// ./src/components/Business/CreateBusiness.js